/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EmailNotificationType {
    getFixupPrototypeFunction() { return EmailNotificationType.fixupPrototype; }

    static newInstance(model: Partial<EmailNotificationType>): EmailNotificationType {
        let obj = Object.assign(new EmailNotificationType(), model);
        EmailNotificationType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EmailNotificationType>): EmailNotificationType {
        if (!model) return null;
        return EmailNotificationType.newInstance(<EmailNotificationType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EmailNotificationType) {
        if (!obj) return;

        models.EmailNotificationType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EmailNotificationType): boolean {
        Object.setPrototypeOf(obj, EmailNotificationType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Display label for the notification type
     */
    label: string;

    /**
     * Unique identifier for the notification type
     */
    name: string;

    /**
     * Whether this notification is enabled by default
     */
    default: boolean;

    /**
     * Human-readable description of the notification type
     */
    description: string;

}
